import { render, staticRenderFns } from "./exccAuthorization.vue?vue&type=template&id=2561c8a2&scoped=true&"
import script from "./exccAuthorization.vue?vue&type=script&lang=js&"
export * from "./exccAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./exccAuthorization.vue?vue&type=style&index=0&id=2561c8a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2561c8a2",
  null
  
)

export default component.exports